import { UserCircleIcon } from "@heroicons/react/24/outline";
import { MagnifyingGlassIcon } from "@heroicons/react/24/solid";
import NavItem from "./NavItem.tsx";
import { useAuth } from "../../hooks/useAuth.tsx";
import { NavLink } from "react-router-dom";

const
    NavMobileTopBar = () => {
        const _authService = useAuth();
        return (
            <div className="fixed top-0 w-screen h-auto bg-neutral-950 z-[60] px-5">
                <ul className="space-x-2 flex justify-between items-center">
                    <li>
                        <NavLink
                            className={"flex flex-col items-center w-full"}
                            to={_authService.token ? "/konto" : "/logowanie"}
                            style={({ isActive }) => {
                                return { color: isActive ? "#008DD2" : "" };
                            }}
                        >
                            <UserCircleIcon className="w-8 h-8" />
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to={"/"}>
                            <img
                                className={"mt-2 my-2 h-10"}
                                src={"/images/logo.png"}
                                alt=""
                            />
                        </NavLink>
                    </li>
                    <li>
                        <NavItem title={""} href={"/szukaj"} icon={<MagnifyingGlassIcon className={"w-7 h-7"} />} />
                    </li>
                </ul>
            </div>
        );
    };

export default NavMobileTopBar;